import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";

const ThankYouPage: React.FC = () => {
    return (
        <div className="bg-background text-foreground min-h-screen flex flex-col">
            <Navbar />
            <div className="container mx-auto px-4 pt-32 pb-20 lg:pt-40 lg:pb-32 flex-1 flex flex-col items-center justify-center text-center">
                <div className="absolute inset-0 -z-10 bg-gradient-to-b from-emerald-50/50 to-background dark:from-emerald-950/20 dark:to-background pointer-events-none" />

                <h1 className="text-4xl font-extrabold tracking-tight text-foreground sm:text-5xl lg:text-6xl mb-6">
                    Thank You!
                </h1>
                <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
                    You've successfully joined the waitlist. We'll be in touch soon with your early access invite.
                </p>
                <Button size="lg" className="rounded-xl px-8" asChild>
                    <Link to="/">Back to Home</Link>
                </Button>
            </div>
        </div>
    );
};

export default ThankYouPage;
